import React from 'react';
import './Buttons.css';

function AuthForm({
    credentials,
    handleChange,
    handleRegister,
    handleLogin,
    handleResetPassword,
    handleConfirmResetPassword,
    errorMessage,
    isRegistering,
    isResetting
}) {

    return (
        <div className="auth-container">
            <h2>{isRegistering
                ? 'Create Your Account'
                : isResetting
                    ? 'Reset Your Password'
                    : 'Welcome Back'}
            </h2>
            <div>
                {isRegistering && (
                    <p>Great things are happening in your garden!</p>
                )}
                {!isRegistering && !isResetting && (
                    <p>Sign in to continue growing.</p>
                )}
            </div>
            <form>
                <div>
                    <label>Username:</label>
                    <input
                        type="text"
                        name="username"
                        value={credentials.username}
                        onChange={handleChange}
                        placeholder="Enter your username"
                        required
                        disabled={isResetting }
                    />
                </div>
                <div>
                    <label>Password:</label>
                    {isResetting ? (
                        <>
                            <input
                                type="password"
                                name="password"
                                value={credentials.password}
                                onChange={handleChange}
                                placeholder="Enter new password"
                                required
                            />
                            <div>
                            <button type="button" className="button" onClick={handleConfirmResetPassword}>
                                Set New Password
                            </button>
                            </div>
                        </>
                    ) : (
                        <>
                    <input
                        type="password"
                        name="password"
                        value={credentials.password}
                        onChange={handleChange}
                        placeholder="Enter your password"
                        required
                    />
                    {/* Forgot password text link */}
                    <span
                        className="forgot-password-text"
                        onClick={(e) => {
                            e.preventDefault();
                            console.log('Forgot Password clicked');
                            handleResetPassword();
                        }}
                        style={{ color: '#007BFF', cursor: 'pointer', marginTop: '4px', display: 'block' }}
                    >
                        Forgot Password?
                    </span>
                    </>
                    )}
                </div>

                {isResetting ? null : (
                    isRegistering ? (
                        <button type="button" className="button" onClick={handleRegister}>
                            Create Account
                        </button>
                    ) : (
                        <button type="button" className="button" onClick={handleLogin}>
                            Sign In
                        </button>
                    )
                )}
                {errorMessage && <p className="error-message">{errorMessage}</p>}
            </form>
        </div>
    );
}

export default AuthForm;
